import { KeysToCamel } from 'helpers/KeysToCamel';
import TYPES from './types';

export const INITIAL_STATE = {
    notifications: [],
};

export const INIT = function () {
    return { ...INITIAL_STATE };
};

const NotificationReducer = function (state, action) {
    switch (action.type) {
        case TYPES.INIT: {
            return { ...INITIAL_STATE };
        }
        case TYPES.SET_NOTIFICATIONS: {
            return { ...state, notifications: action.payload.map((notif) => formatNotificationIntoState(notif)) };
        }
        case TYPES.UPDATE_NOTIFICATION: {
            const { id, messageId, read } = action.payload;

            const newNotifs = state.notifications.map((notif) => {
                if ((notif.id && (notif.id === id)) || (notif.messageId && (notif.messageId === messageId))) {
                    return { ...notif, read };
                }

                return { ...notif };
            });

            return { ...state, notifications: newNotifs };
        }
        case TYPES.ADD_FCM_NOTIFICATION: {
            if (state.notifications.findIndex((item) => item.messageId === action.payload.messageId) === -1) {
                const newNotif = { ...formatNotificationIntoState(action.payload), read: false };
                state.notifications.push(newNotif);
            }
            return { ...state };
        }
        default: {
            return { ...state };
        }
    }
};

const formatNotificationIntoState = (notification) => {
    let formattedNotification = KeysToCamel(notification);
    const { id, messageId, ...rest } = formattedNotification;

    if (messageId) {
        formattedNotification = { id: messageId, messageId: messageId, ...rest };
    } else if (id) {
        formattedNotification = { id: id, ...rest };
    }

    return formattedNotification;
};

export default NotificationReducer;
